import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, closeDrawer, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import DatePicker from 'react-datepicker';
import moment from 'moment';

// Components
import TimeSelect2 from '../Modules/TimeSelect2';

const EditCourseOffering = observer(class EditCourseOffering extends React.Component {
  constructor() {
    super();
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
  }

  componentWillMount() {
    const { SessionStore } = this.props.store;

    this.state = {
      startDate: null,
      endDate: null,
      matchStrings: null
    }

    SessionStore.getTimezones();
    SessionStore.getCurrencies();

    if(getURLSegment(this, 2) === 'edit') {
      const offeringSid = getURLSegment(this, 3);
      this.getCourseOffering(offeringSid);
    }
  }

  getCourseOffering(offeringSid) {
    this.props.store.CourseStore.getCourseOffering(offeringSid, this);
  }

  handleInput(e, name) {
    const data = {
      [name]: e.target.value
    };

    if(name === 'matchStrings') {
      this.setState({
        matchStrings: e.target.value
      });
    }

    this.props.store.CourseStore.updateOfferingData(data);
  }

  handleDateChange(date, name, isDateField) {
    let time = null

    if(!date) {
      if(name === 'startDate') {
        date = this.state.startDate;
      } else {
        date = this.state.endDate;
      }
    }

    if(name === 'startDate') {
      time = this.startTime.value;
    } else {
      time = this.endTime.value;
    }

    const { userTimezone } = this.props.store.SessionStore;
    const dateString = moment(date).format('YYYY-MM-DD');
    const timezoneString = moment(date).tz(userTimezone).format('Z');
    const newDate = moment.utc(`${dateString} ${time} ${timezoneString}`, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();

    const data = {
      [name]: newDate
    }

    if(date) {
      this.setState({
        [name]: moment(newDate)
      });
    }

    this.props.store.CourseStore.updateOfferingData(data);
  }

  handleSubmit() {
    const offeringSid = getURLSegment(this, 3);

    if(offeringSid) {
      this.props.store.CourseStore.updateCourseOffering(offeringSid, this.complete);
    } else {
      this.props.store.CourseStore.createCourseOffering(this.complete);
    }
  }

  complete() {
    closeDrawer(null, this.props.parent, getURLSegment(this, 1));
    this.props.store.SessionStore.showToaster(this.props.translation.offering_saved, 'success');
    this.props.getCourseOfferings(true);
  }

  render() {
    const { translation } = this.props;
    const { CourseStore, SessionStore } = this.props.store;
    const { offering } = CourseStore;
    const offeringSid = getURLSegment(this, 3);
    const { userTimezone } = this.props.store.SessionStore;

    if(!SessionStore.loading) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              {offeringSid &&
                <h1 className="drawer__title">{translation.edit_heading}</h1>
              }

              {!offeringSid &&
                <h1 className="drawer__title">{translation.add_heading}</h1>
              }
            </div>
          </header>

          <div className="wrap">
            <form className="panel panel--medium" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
              <fieldset>
                <ul className="fields">
                  <li>
                    <label className="lbl-required" htmlFor="offering-title">{translation.title.label}</label>
                    <input
                      type="text"
                      id="offering-title"
                      ref={(input) => {this.title = input}}
                      onChange={(e) => {this.handleInput(e, 'title')}}
                      defaultValue={offering.title}
                      required
                      aria-required="true"
                    />
                  </li>
                  <li>
                    <label className="lbl-required" htmlFor="offering-regex">{translation.regex.label}</label>
                    <input
                      type="text"
                      id="offering-regex"
                      ref={(input) => {this.matchStrings = input}}
                      onChange={(e) => {this.handleInput(e, 'matchStrings')}}
                      defaultValue={offering.matchStrings}
                      required
                      aria-required="true"
                      aria-invalid={this.state.matchStrings === '*'}
                    />
                  </li>
                  <li className="field--auto">
                    <label className="lbl-required" htmlFor="offering-start">{translation.starts.label}</label>

                    <DatePicker
                      id="offering-start"
                      selected={offering.startDate ? moment(offering.startDate).tz(userTimezone) : null}
                      onChange={(date) => {this.handleDateChange(date, 'startDate', true)}}
                      ref={(input) => {this.startDate = input}}
                      placeholderText={translation.starts.helper}
                      required
                      aria-required="true"
                      autoComplete="off"
                    />

                    <span className="preposition">at</span>

                    <label className="select">
                      <select
                        id="offering-start-time"
                        defaultValue={moment.utc(offering.startDate).tz(userTimezone).format('HH:mm')}
                        ref={(input) => {this.startTime = input}}
                        onChange={() => this.handleDateChange(null, 'startDate', false)}
                      >
                        <TimeSelect2 />
                      </select>
                    </label>

                    <span className="preposition">
                      {/* If a date is selected, use that date’s dst */}
                      {this.state.startDate &&
                        moment.utc(this.state.startDate).tz(userTimezone).format('z')
                      }

                      {/* Otherwise use the current date’s dst */}
                      {!this.state.startDate &&
                        moment().tz(userTimezone).format('z')
                      }
                    </span>
                  </li>
                  <li className="field--auto">
                    <label className="lbl-required" htmlFor="offering-end">{translation.ends.label}</label>
                    <DatePicker
                      id="offering-end"
                      selected={offering.endDate ? moment(offering.endDate).tz(userTimezone) : null}
                      onChange={(date) => {this.handleDateChange(date, 'endDate', true)}}
                      ref={(input) => {this.endDate = input}}
                      placeholderText={translation.ends.helper}
                      required
                      aria-required="true"
                      autoComplete="off"
                    />

                    <span className="preposition">at</span>

                    <label className="select">
                      <select
                        id="offering-start-time"
                        defaultValue={moment.utc(offering.endDate).tz(userTimezone).format('HH:mm')}
                        ref={(input) => {this.endTime = input}}
                        onChange={() => this.handleDateChange(null, 'endDate', false)}
                      >
                        <TimeSelect2 />
                      </select>
                    </label>

                    <span className="preposition">
                      {/* If a date is selected, use that date’s dst */}
                      {this.state.endDate &&
                        moment.utc(this.state.endDate).tz(userTimezone).format('z')
                      }

                      {/* Otherwise use the current date’s dst */}
                      {!this.state.endDate &&
                        moment().tz(userTimezone).format('z')
                      }
                    </span>
                  </li>
                </ul>
              </fieldset>

              <div className="panel__actions actions">
                {offeringSid &&
                  <button
                    className="actions__btn actions__btn--primary"
                  >
                    {translation.edit_button}
                  </button>
                }

                {!offeringSid &&
                  <button
                    className="actions__btn actions__btn--primary"
                  >
                    {translation.add_button}
                  </button>
                }
              </div>
            </form>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('EditCourseOffering')(EditCourseOffering);



// WEBPACK FOOTER //
// ./src/app/components/CourseOfferings/EditCourseOffering.js